import { render, staticRenderFns } from "./flex-layout.vue?vue&type=template&id=5f5db08a&"
import script from "./flex-layout.vue?vue&type=script&lang=js&"
export * from "./flex-layout.vue?vue&type=script&lang=js&"
import style0 from "./flex-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports